import IndustrySolutionI18n from "@/components/landing/shared/IndustrySolutionI18n";
import { ShoppingBag, Clock, Package, MessageSquare } from "lucide-react";
const LoesungECommerceSection = () => <IndustrySolutionI18n translationPrefix="industryECommerce" icons={[ShoppingBag, Clock, Package, MessageSquare]} />;
export default LoesungECommerceSection;
